import { setLocale } from 'yup';
import  formMsg from '../locale/forms'

setLocale(formMsg);